import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
export default {
  data: function data() {
    return {
      showSetting: false,
      pageSet: {
        shareTitle: "",
        desc: "",
        dynamicTags: [],
        shareImg: "",
        absoluteUrl: "",
        bgColor: ""
      },
      setDataChange: false,
      inputVisible: false,
      inputValue: '',
      predefineColors: ['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585', 'rgba(255, 69, 0, 0.68)', 'rgb(255, 120, 0)', 'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)']
    };
  },
  components: {},
  computed: {
    pageSetData: {
      get: function get() {
        return this.$store.state.divpageShop.pageSetData;
      },
      set: function set(newVal) {
        this.$store.commit('updateData', {
          pageSetData: newVal
        });
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: _objectSpread(_objectSpread({}, mapMutations(['updateData'])), {}, {
    // 页面设置
    pageSetting: function pageSetting() {
      var that = this;
      that.showSetBlock = false;
      that.showSetBtn = false;
    },
    // 删除关键词
    handleClose: function handleClose(tag) {
      this.pageSet.dynamicTags.splice(this.pageSet.dynamicTags.indexOf(tag), 1);
    },
    // 展示关键词 input
    showInput: function showInput() {
      var _this = this;
      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    // 新增页面关键词
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.pageSet.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    popoverClose: function popoverClose() {
      var that = this;
      that.setDataChange && that.submitPageSet(false);
    },
    // 提交页面设置内容
    submitPageSet: function submitPageSet() {
      var showMsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var that = this;
      that.axios.post('/v2/activity/diy/share/update', {
        id: that.pageSet.id,
        title: that.pageSet.shareTitle,
        description: that.pageSet.desc,
        keyWords: that.pageSet.dynamicTags.join(','),
        shareImagePath: that.pageSet.absoluteUrl,
        backgroundColor: that.pageSet.bgColor
      }).then(function (res) {
        if (res.data.ret == 0) {
          that.updateData({
            pageSetConfig: that.pageSet
          });
          showMsg && that.$message.success(res.data.msg);
          that.showSetting = false;
        } else {
          showMsg && that.$message.error(res.data.msg);
        }
      });
    },
    floorPlanSuccess: function floorPlanSuccess(file) {
      var that = this;
      that.$set(that.pageSet, "shareImg", file.fullPath);
      that.$set(that.pageSet, "absoluteUrl", file.path);
    },
    uploadPicBefore: function uploadPicBefore(file) {
      var that = this;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
        that.$notify({
          duration: 1500,
          message: '请上传图片格式文件',
          type: 'error'
        });
        return false;
      } else if (!isLt2M) {
        that.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }
    }
  }),
  watch: {
    pageSetData: {
      handler: function handler(newVal, oldVal) {
        this.pageSet = newVal;
        this.setDataChange = !this.IsEmptyObj(oldVal);
      },
      deep: true
    }
  }
};